import { translate } from "@klantondersteuning-btl/shared";
import * as React from "react";

export const IntroNL = () => {
  return (
    <div className="pt-4 intro">
      <h1>{translate("EhicFormulier")}</h1>
      <p>
        Met dit formulier vraagt u voor een gezinslid een Europese zorgpas (EHIC) aan. Dit kunt u pas doen na
        de inschrijfdatum bij het CAK. Vul een apart formulier in voor elk gezinslid dat via ons verzekerd is.
      </p>
      <p className="form-notification-block form-notification-block--tip">
        <strong>Tip</strong>
        <br />
        Dit formulier is alleen voor gezinsleden van grensarbeiders. Krijgt u een Nederlands pensioen of
        uitkering en woont u in het buitenland? Dan krijgen u en uw gezinsleden de EHIC automatisch
        opgestuurd.
      </p>
      <br />
    </div>
  );
};
